import EnterpriseSWIcon from "../../assets/product-list-assets/aggregation.svg";
import type { ProductListGroup } from "../../types";

export const productListSwitchingEnterprise: ProductListGroup = {
  id: "productListSwitchingEnterprise",
  title: "productListGroup.switchingEnterprise.title",
  icon: {
    src: EnterpriseSWIcon,
    width: 22,
    height: 22,
  },
};
